import { ExtCancelLoginError, ExtError, ExtInternalError, ExtNotSupportError } from "@hyext-inner/ext-web-comp";
import { InnerExtAdapter } from "@hyext-inner/inner-ext-web-comp";
import { NORMAL_TIMEOUT, SUP_HOST, SUP_INNER_HOST, WUP_TIMEOUT } from "../../config/const";
import { BusType, EventName, HyTafFuncName, HyTafUI, HyTafURI } from "../../util/hy";
import { barrageJceToBarrageInfo, giftJceToGiftInfo, guardianPresenterInfoNoticeToOpenGuardianInfo, nobleLevelNoticeToOpenNobleInfo, nobleNoticeToOpenNobleInfo, vipEnterBannerToVipEnterInfo } from "../../util/jce";
import { promiseTimeout } from "../../util/promise";
import HyExtEndpointModule from "../ext/HyExtEndpointModule";

const DEFAULT_USER_LEVEL = {
  userLevel: 0,
  currLevelExp: 0,
  nextLevelExp: 0,
  dailyIncExp: 0,
  noble: {
    validDate: 0,
    nobleName: '',
    nobleLevel: 0
  }
}

const USER_LVEL_API = (process.env.NODE_ENV === 'development' || process.env.BUILD_MODE === 'test')
  ? '//taskapi-webtest.huya.com/task/taskTotal'
  : '//live.huya.com/task/taskTotal'

let gReqId:number = 100000

export default abstract class HyExtAdapter extends InnerExtAdapter implements HyExtCompInitOptions {
  TT:TT
  TTA: TTA
  roomFollow: RoomFollow
  constructor(options:HyExtCompInitOptions) {
    super()

    this.TT = options.TT
  }
  async handleMessage() {
    await super.handleMessage()
    this.addTafListener(HyTafURI.kSecPackVipEnterBanner, async (data:HUYA.VipEnterBanner) => {
      this.extEndpointModulesManager.extEndpointModuleList.forEach(async (hyExtEndpointModule:HyExtEndpointModule) => {
        const vipEnterInfo = await vipEnterBannerToVipEnterInfo(data, hyExtEndpointModule.extMain, this)
        hyExtEndpointModule.bus.getBus(BusType.VIP).emit(EventName.VIP_ENTER_BANNER_NOTICE, vipEnterInfo)
      })
    })
    this.addTafListener(HyTafURI.kSecPackTypeGuardianPresenterInfoNotice, async (data:HUYA.GuardianPresenterInfoNotice) => {
      this.extEndpointModulesManager.extEndpointModuleList.forEach(async (hyExtEndpointModule:HyExtEndpointModule) => {
        const openGuardianInfo = await guardianPresenterInfoNoticeToOpenGuardianInfo(data, hyExtEndpointModule.extMain, this)
        hyExtEndpointModule.bus.getBus(BusType.GUARDIAN).emit(EventName.OPEN_GUARDIAN_NOTICE, openGuardianInfo)
      })
    })
    this.addTafListener(HyTafURI.kSecPackTypeNewNobleNotice, async (data:HUYA.NobleNotice) => {
      this.extEndpointModulesManager.extEndpointModuleList.forEach(async (hyExtEndpointModule:HyExtEndpointModule) => {
        const openNobleInfo = await nobleNoticeToOpenNobleInfo(data, hyExtEndpointModule.extMain, this)
        hyExtEndpointModule.bus.getBus(BusType.NOBLE).emit(EventName.OPEN_NOBLE_NOTICE, openNobleInfo)
      })
    })
    this.addTafListener(HyTafURI.kSecPackTypeNewNobleLevelNotice, async (data:HUYA.NobleLevelNotice) => {
      this.extEndpointModulesManager.extEndpointModuleList.forEach(async (hyExtEndpointModule:HyExtEndpointModule) => {
        const openNobleInfo = await nobleLevelNoticeToOpenNobleInfo(data, hyExtEndpointModule.extMain, this)
        hyExtEndpointModule.bus.getBus(BusType.NOBLE).emit(EventName.OPEN_NOBLE_NOTICE, openNobleInfo)
      })
    })
    this.addTafListener(HyTafURI.kSecPackTypeItemConsumSubNotify, async (data:HUYA.SendItemSubBroadcastPacket) => {
      const userId = await this.getUserId()
      this.extEndpointModulesManager.extEndpointModuleList.forEach(async (hyExtEndpointModule:HyExtEndpointModule) => {
        const giftInfo = await giftJceToGiftInfo(data, hyExtEndpointModule.extMain, this)
        hyExtEndpointModule.bus.getBus(BusType.GIFT).emit(EventName.GIFT_CHANGE, giftInfo)
        if (String(data.lSenderUid) === String(userId.lUid)) {
          hyExtEndpointModule.postGiftSubmit(giftInfo, this)
        }
      })
    })
    this.addTafListener(HyTafURI.kSecPackTypeMessageNotice, async (data:HUYA.MessageNotice) => {
      const userId = await this.getUserId()
      this.extEndpointModulesManager.extEndpointModuleList.forEach(async (hyExtEndpointModule:HyExtEndpointModule) => {
        const barrageInfo = await barrageJceToBarrageInfo(data, hyExtEndpointModule.extMain, this)
        hyExtEndpointModule.bus.getBus(BusType.BARRAGE).emit(EventName.BARRAGE_CHANGE, barrageInfo)
        if (String(data.tUserInfo.lUid) === String(userId.lUid)) {
          hyExtEndpointModule.postBarrageSubmit(barrageInfo, this)
        }
      })
    })
  }
  isOriginValid(origin: string): Promise<boolean> {
    return Promise.resolve(
      origin.indexOf(SUP_HOST) >= 0 ||
      origin.indexOf(SUP_INNER_HOST) >= 0
    )
  }
  getHyUserInfo():Promise<UserInfo> {
    return promiseTimeout<UserInfo>(
      NORMAL_TIMEOUT,
      '获取用户信息超时',
      new Promise<UserInfo>(resolve => {
        this.TT.getUserInfo(userInfo => resolve(userInfo))
      })
    )
  }
  async getHyUserLevel():Promise<GetUserLevelResp> {
    const { lUid } = await this.getUserId()
    if (Number(lUid) === 0) {
      return Promise.resolve(DEFAULT_USER_LEVEL)
    } else {
      return new Promise<GetUserLevelResp>((resolve, reject) => {
        $.ajax({
          url: `${USER_LVEL_API}?uid=${lUid}`,
          dataType: 'jsonp',
          success: (json: any) => {
            if (json &&
              json.data &&
              json.data.level &&
              json.data.level.userLevel) {
              resolve({
                userLevel: Number(json.data.level.userLevel),
                currLevelExp: Number(json.data.level.currLevelExp),
                nextLevelExp: Number(json.data.level.nextLevelExp),
                dailyIncExp: Number(json.data.level.dailyIncExp),
                noble: {
                  validDate: Number(json.data.noble.levelAttr.lValidDate),
                  nobleName: json.data.noble.nobleName,
                  nobleLevel: Number(json.data.noble.nobleLevel)
                }
              })
            } else {
              resolve(DEFAULT_USER_LEVEL)
            }
          },
          error: () => {
            resolve(DEFAULT_USER_LEVEL)
          },
          timeout: 1000,
        })
      })
    }
  }
  async sendWup2(ui:HyTafUI, funcName:HyTafFuncName, req:any):Promise<any> {
    const reqId = gReqId++
    req.tId = await this.getUserId()
    this.logger.debug('发送taf请求', { ui, funcName, req, reqId })
    const rsp:ITafRsp = await promiseTimeout(
      WUP_TIMEOUT,
      `调用${funcName}超时`,
      this.sendWupImpl(ui, funcName, req, reqId)
    )
    if (rsp.iRequestId === reqId) {
      const { response } = rsp
      if (response) {
        const { res, msg } = response
        if (res === 0) {
          this.logger.debug('发送taf请求成功', { ui, funcName, req, reqId, rsp })
          return Promise.resolve(rsp)
        } else {
          this.logger.warn('发送taf请求失败', { ui, funcName, req, reqId, res, msg })
          return Promise.reject(new ExtError(res, msg))
        }
      } else {
        this.logger.warn('发送taf请求失败，返回结构错误', { ui, funcName, req, reqId, rsp })
        return Promise.reject(new ExtInternalError())
      }
    } else {
      this.logger.warn('发送taf请求失败，iRequestId对不上', { ui, funcName, req, reqId, rsp })
      return Promise.reject(new ExtInternalError())
    }
  }
  getProfileExtList(req:MidExtQuery.GetProfileExtListReq): Promise<MidExtQuery.GetProfileExtListResp> {
    return this.sendWup2(HyTafUI.EXT_QUERY_UI, HyTafFuncName.GET_PROFILE_EXT_LIST, req)
  }
  getPositionExtList(req:MidExtQuery.GetPositionExtListReq):Promise<MidExtQuery.GetPositionExtListResp> {
    return this.sendWup2(HyTafUI.EXT_QUERY_UI, HyTafFuncName.GET_POSITION_EXT_LIST, req)
  }
  getUserExtAuthorizeInfo(req: MidExtAuth.GetUserExtAuthorizeReq): Promise<MidExtAuth.GetUserExtAuthorizeResp> {
    return this.sendWup2(HyTafUI.EXT_AUTH_UI, HyTafFuncName.GET_USER_EXT_AUTHORIZE_INFO, req)
  }
  userExtAuthorize(req: MidExtAuth.UserExtAuthorizeReq): Promise<MidExtAuth.UserExtAuthorizeResp> {
    return this.sendWup2(HyTafUI.EXT_AUTH_UI, HyTafFuncName.USER_EXT_AUTHORIZE, req)
  }
  getJWT(req: MidExtAuth.GetJWTReq): Promise<MidExtAuth.GetJWTResp> {
    return this.sendWup2(HyTafUI.EXT_AUTH_UI, HyTafFuncName.GET_JWT, req)
  }
  routeEbsRequestV2(req: MidExtProxyRoute.RouteEBSV2Req): Promise<MidExtProxyRoute.RouteEBSV2Resp> {
    return this.sendWup2(HyTafUI.EXT_ROUTE_UI, HyTafFuncName.ROUTE_EBS_REQUEST_V2, req)
  }
  getStorageKey(req:MidExtCapability.GetStorageKeyReq):Promise<MidExtCapability.GetStorageKeyResp> {
    return this.sendWup2(HyTafUI.EXT_CAPABILITY_UI, HyTafFuncName.GET_STORAGE_KEY, req)
  }
  setStorage(req:MidExtCapability.SetStorageReq):Promise<MidExtCapability.SetStorageResp> {
    return this.sendWup2(HyTafUI.EXT_CAPABILITY_UI, HyTafFuncName.SET_STORAGE, req)
  }
  getStorageAllKeys(req:MidExtCapability.GetStorageAllKeysReq):Promise<MidExtCapability.GetStorageAllKeysResp> {
    return this.sendWup2(HyTafUI.EXT_CAPABILITY_UI, HyTafFuncName.GET_STORAGE_ALL_KEYS, req)
  }
  delStorageKey(req:MidExtCapability.DelStorageKeyReq):Promise<MidExtCapability.DelStorageKeyResp> {
    return this.sendWup2(HyTafUI.EXT_CAPABILITY_UI, HyTafFuncName.DEL_STORAGE_KEY, req)
  }
  getPicUploadPolicy(req:MidExtCapability.GetPicUploadPolicyReq):Promise<MidExtCapability.GetPicUploadPolicyResp> {
    return this.sendWup2(HyTafUI.EXT_CAPABILITY_UI, HyTafFuncName.GET_PIC_UPLOAD_POLICY, req)
  }
  textReportSDKFormExt(req: MidExtInspection.TextReportSDKFormExtReq): Promise<MidExtInspection.TextReportSDKFormExtResp> {
    return this.sendWup2(HyTafUI.EXT_INSPECTION_UI, HyTafFuncName.TEXT_REPORT_SDK_FORM_EXT, req)
  }
  commonBusiness(req:MidExtCommonQuery.CommonQueryReq):Promise<MidExtCommonQuery.CommonQueryResp> {
    return this.sendWup2(HyTafUI.EXT_COMMON_QUERY_UI, HyTafFuncName.COMMON_BUSINESS, req)
  }
  getHostId(): string {
    return 'huyaext'
  }
  addDevExtMessageSystemHandler(handler: (data: DEV.Message) => void): Promise<void> {
    return this.addTafListener(HyTafURI.kSecPackTypeDevExtMessageSystem, (data:DEV.Message) => handler(data))
  }
  addDevExtMessagePushHandler(handler: (data: DEV.Message) => void): Promise<void> {
    return this.addTafListener(HyTafURI.kSecPackTypeDevExtMessagePush, (data:DEV.Message) => handler(data))
  }
  addDevLiveEventMessagePushHandler(handler: (data:DEV.LiveEventMessage) => void):Promise<void> {
    return this.addTafListener(HyTafURI.kSecPackTypeDevExtLiveEventMessage, (data:DEV.LiveEventMessage) => handler(data))
  }
  login(): Promise<void> {
    return new Promise((resolve, reject) => {
      const cancelHandler = () => {
        this.TT.login.off('loginClose', cancelHandler)
        reject(new ExtCancelLoginError())
      }
      this.TT.login.on('loginClose', cancelHandler)
      this.TT.login.login()
    })
  }
  getSupUrl(extMain: MidExtQuery.ExtMain): string {
    if (extMain.extAppCspPolicy.hostLevel === 3) {
      return `//${SUP_INNER_HOST}/ext-web-mid/ext-web-sub-frame/${process.env.SUP_VERSION || 'test'}/index.html`
    } else {
      return `//${SUP_HOST}/ext-web-mid/ext-web-sub-frame/${process.env.SUP_VERSION || 'test'}/index.html`
    }
  }
  getSupHost(extMain: MidExtQuery.ExtMain): string {
    if (extMain.extAppCspPolicy.hostLevel === 3) {
      return SUP_INNER_HOST
    } else {
      return SUP_HOST
    }
  }
  getAnonymJWT(req: MidExtAuth.GetAnonymJWTReq): Promise<MidExtAuth.GetAnonymJWTResp> {
    return this.sendWup2(HyTafUI.EXT_AUTH_UI, HyTafFuncName.GET_ANONYM_JWT, req)
  }
  logout(): Promise<void> {
    return this.TT.login.logout()
  }
  // 无用的接口
  getWebPanelContainer(extMain: MidExtQuery.ExtMain, extComEndpoint: MidExtQuery.ExtComEndpoint): Promise<any> {
    throw new Error("Method not implemented.");
  }
  getWebPanelEntranceContainer(extMain: MidExtQuery.ExtMain, extComEndpoint: MidExtQuery.ExtComEndpoint): Promise<any> {
    throw new Error("Method not implemented.");
  }
  // 抽象方法
  abstract sendWupImpl(ui:string, funcName:string, req:any, reqId:number):Promise<ITafRsp>
  abstract openUrl(url:string):Promise<void>
  abstract getGiftData():Promise<Array<HyGiftItem>>
  abstract sendGiftToUser(uid: number, giftId: number, giftCount: number, sSrcType: string): Promise<{ res: number, msg: string }>
  abstract sendGift(giftId: number, giftCount: number, sSrcType: string): Promise<void>
  abstract addTafListener(uri:string, handler:Function):Promise<void>
  abstract subscribe(): Promise<void>
  abstract leadGift(): Promise<void>
  abstract leadBarrage(): Promise<void>
  abstract wsConnect(url: string): Promise<{ wsId: string }>
  abstract wsSend(wsId: string, message: any): Promise<void>
  abstract wsClose(wsId: string, code: number, reason: string): Promise<void>
}